import { DataTable, Column, Badge } from '../../../shared/components';
import { OperationTimeRecord } from '../../../shared/services/operationTimes/types';
import { formatDateTime, formatDuration } from '../../../shared/utils/datetime';

/**
 * Tabla de Consolidado - INDEPENDIENTE de ActivityHistoryTable (Control de
 * Tiempos). Muestra todos los usuarios y todos los campos, incluida
 * "Modificado / Borrado" (solo lectura: esta pantalla es de consulta y
 * descarga, no edita ni elimina registros - para eso ya existen Tiempos y
 * Auditoría).
 */
function NovedadCell({ record }: { record: OperationTimeRecord }) {
  if (record.novedad === 'none') return <span className="text-ink-300">—</span>;
  const isDeleted = record.novedad === 'deleted';
  const label = isDeleted ? 'Borrado' : 'Modificado';
  const reason = record.novedadReason?.trim();
  const title = reason ? `${label}, ${reason}` : label;
  return (
    <span
      title={title}
      className={[
        'inline-flex max-w-[220px] cursor-help items-center truncate rounded-full px-2.5 py-1 text-xs font-semibold',
        isDeleted ? 'bg-orange-200 text-orange-900' : 'bg-amber-100 text-amber-800',
      ].join(' ')}
    >
      {title}
    </span>
  );
}

interface ConsolidadoTableProps {
  rows: OperationTimeRecord[];
  isLoading?: boolean;
}

export function ConsolidadoTable({ rows, isLoading }: ConsolidadoTableProps) {
  const columns: Column<OperationTimeRecord>[] = [
    { key: 'code', header: 'Código', render: (r) => <span className="font-mono text-xs text-ink-400">{r.code}</span> },
    { key: 'userName', header: 'Usuario', render: (r) => r.userName, sortable: true, sortValue: (r) => r.userName },
    { key: 'activityName', header: 'Actividad', render: (r) => <Badge tone="success">{r.activityName}</Badge> },
    { key: 'start', header: 'Inicio', render: (r) => formatDateTime(r.startDateTime), sortable: true, sortValue: (r) => r.startDateTime },
    { key: 'end', header: 'Fin', render: (r) => formatDateTime(r.endDateTime) },
    { key: 'duration', header: 'Duración', render: (r) => <span className="font-semibold">{formatDuration(r.durationSeconds)}</span> },
    { key: 'observations', header: 'Observaciones', render: (r) => <span className="text-ink-400">{r.observations || '—'}</span> },
    { key: 'novedad', header: 'Modificado / Borrado', render: (r) => <NovedadCell record={r} /> },
  ];

  return (
    <DataTable
      columns={columns}
      rows={rows}
      rowKey={(r) => r.id}
      isLoading={isLoading}
      emptyTitle="Sin registros"
      emptyDescription="No hay registros para los filtros seleccionados."
      pageSize={10}
      defaultSortKey="start"
      defaultSortDir="desc"
    />
  );
}
